<template>
  <div class="text-center">
    <div class="row no-gutters justify-content-between mb-1">
      <div class="col-sm-auto flex-grow-0">

      </div>
    </div>
    <div class="row  my-3">
<!--      <div class="col-1 text-left">-->
<!--        <label for="month" class="col-form-label">YEAR</label>-->
<!--      </div>-->
<!--      <div class="col-4">-->
<!--        <select name="month" id="month" class="form-control form-control-sm" v-model="params.year" :disabled="isLoading">-->
<!--          <option :value="null">-&#45;&#45; ALL YEAR -&#45;&#45;</option>-->
<!--          <option :value="year" v-for="year in years">{{year}}</option>-->
<!--        </select>-->
<!--      </div>-->

      <div class="col-1 text-left">
        <small  class="col-form-label">RISQ Finding Sections</small>
      </div>
      <div class="col-4">
        <button class="custom-button btn border btn-block text-left btn-sm"
                data-target="#risqFindingSectionsModal"
                data-toggle="modal"
                style="padding-top: .35rem; padding-bottom: .35rem;"
                :disabled="params.rs_code.length > 0 || isLoading"
        >
           <span style="font-size: 14px;">
              {{ showSelectedRsSections }}
           </span>
          <span style="float: right">
                      <font-awesome-icon icon="chevron-down"/>
                    </span>
        </button>
      </div>

      <div class="col-1 text-left">
        <small  class="col-form-label">Revision Number</small>
      </div>
      <div class="col-4">
        <button class="custom-button btn border btn-block text-left btn-sm"
                data-target="#risqFindingRevisionsModal"
                data-toggle="modal"
                style="padding-top: .35rem; padding-bottom: .35rem;"
                :disabled="isLoading"
        >
           <span style="font-size: 14px;">
              {{ showSelectedRsRevisions }}
           </span>
          <span style="float: right">
                      <font-awesome-icon icon="chevron-down"/>
                    </span>
        </button>
      </div>

      <div class="col-2">
        <button id="commonFindingsReport" @click="resetFilter" class="e-btn e-btn-blue-gray force-white-all">
          <font-awesome-icon class="mr-1" icon="filter"/>
          Reset Filter
        </button>
      </div>

    </div>

    <div class="row my-3">
<!--      <div class="col-1 text-left">-->
<!--        <label for="month" class="col-form-label">Month</label>-->
<!--      </div>-->
<!--      <div class="col-4">-->
<!--        <select name="month" id="month" class="form-control form-control-sm" v-model="params.month" :disabled="isLoading">-->
<!--          <option :value="null">-&#45;&#45; ALL PERIOD -&#45;&#45;</option>-->
<!--          <option :value="month.id" v-for="month in months">{{month.name}}</option>-->
<!--        </select>-->
<!--      </div>-->

      <div class="col-1 text-left">
        <small  class="col-form-label">RISQ Findings</small>
      </div>
      <div class="col-4">
        <button class="custom-button btn border btn-block text-left btn-sm"
                data-target="#risqFindingCodesModal"
                data-toggle="modal"
                style="padding-top: .35rem; padding-bottom: .35rem;"
                :disabled="params.rs_section.length > 0 || isLoading"
        >
           <span style="font-size: 14px;">
              {{ showSelectedRsCodes }}
           </span>
          <span style="float: right">
                      <font-awesome-icon icon="chevron-down"/>
                    </span>
        </button>
      </div>

      <div class="col-1 text-left">
        <small  class="col-form-label">Type of RISQ Findings</small>
      </div>
      <div class="col-4">
        <button class="custom-button btn border btn-block text-left btn-sm"
                data-target="#risqTypeOfFindingsModal"
                data-toggle="modal"
                style="padding-top: .35rem; padding-bottom: .35rem;"
                :disabled="isLoading"
        >
           <span style="font-size: 14px;">
              {{ showSelectedRsTypes }}
           </span>
          <span style="float: right">
                      <font-awesome-icon icon="chevron-down"/>
                    </span>
        </button>
      </div>

      <div class="col-2">
        <div class="float-right text-right ml-2 dropdown dropright" v-if="['k-line-persons', 'k-line-persons2'].includes(user.roles_permissions?.roles[0]) === false">
          <button id="commonFindingsReport" aria-expanded="false" aria-haspopup="true" v-show="commonFindingsReportRs.length" class="mr-2 e-btn e-btn-blue-gray force-white-all"
                  data-toggle="dropdown">
            <font-awesome-icon class="mr-1" icon="download"/>
            Download Common Findings Report
          </button>
          <div aria-labelledby="commonFindingsReport" class="dropdown-menu">
            <button class="dropdown-item text-secondary font-weight-bolder" @click="downloadReport('excel')" type="button">
              <font-awesome-icon icon="file-excel"/>
              Excel
            </button>
<!--            <button class="dropdown-item text-secondary font-weight-bolder" @click.prevent="downloadReport('pdf')" type="button">-->
<!--              <font-awesome-icon icon="file-pdf"/>-->
<!--              PDF-->
<!--            </button>-->
          </div>
        </div>
      </div>

    </div>
<!--    <div class="row my-3">-->
<!--      <div class="col-1 text-left">-->
<!--        <label for="vessel" class="col-form-label">Vessel</label>-->
<!--      </div>-->
<!--      <div class="col-4">-->
<!--        <select name="vessel" id="month" class="form-control form-control-sm" v-model="params.vessel" :disabled="isLoading">-->
<!--          <option :value="null">-&#45;&#45; ALL VESSEL -&#45;&#45;</option>-->
<!--          <option :value="vessel.id" v-for="vessel in vesselKeys">{{vessel.name | toUpper}}</option>-->
<!--        </select>-->
<!--      </div>-->
<!--    </div>-->

<!--    <div class="row my-3">-->

<!--    </div>-->


    <div class="row no-gutters align-items-center justify-content-between">
      <div class="col-sm-auto pb-2 mr-2">
        <nav aria-label="...">
          <ul class="pagination text-smallest mb-0 pb-0">
            <li class="page-item" :class="{ 'disabled': pagination.currentPage === 1}">
              <button class="page-link" @click="setPage(1)">First</button>
            </li>

            <li v-for="page in paginationPages" :key="page" class="page-item"
                :class="{ 'disabled': page === '...', 'active': page === pagination.currentPage }">
              <button class="page-link" @click="setPage(page)">{{ page }}</button>
            </li>

            <li class="page-item" :class="{ 'disabled': pagination.currentPage === pagination.lastPage}">
              <button class="page-link" @click="setPage(pagination.lastPage)">Last</button>
            </li>
          </ul>
        </nav>
      </div>
    </div>
    <template>
      <div class="text-center">
        <div class="row no-gutters" style="height: 75vh; overflow-y: auto">
          <div class="col-12">
            <table class="small e-tbl">
              <thead class="bg-white" style="position: sticky; top: 0; z-index: 2">
              <tr>
                <th class="align-middle" scope="col">#</th>
                <th class="align-middle" style="width: 12em" scope="col" @click="changeSortingPosition('finding_code')">
                  <div class="white-space-no-wrap">
                      RISQ FINDING CODE
                      <span style="cursor: pointer" class="h6 ml-2">
                       <font-awesome-icon icon="arrow-up" v-if="params.direction === 'asc' && params.order_by === 'finding_code'" class="sort-arrow-up"/>
                      <font-awesome-icon icon="arrow-down" v-else-if="params.direction === 'desc' && params.order_by === 'finding_code'" class="sort-arrow-down"/>
                      <font-awesome-icon icon="sort" v-else/>
                    </span>
                  </div>
                </th>
                <th class="align-middle" style="width: 12em" scope="col">RISQ FINDING TYPE</th>
                <th class="align-middle" style="width: 12em" scope="col">RISQ FINDING DESCRIPTION</th>
                <th class="align-middle" style="width: 12em" scope="col">ROOT CAUSE</th>
                <th class="align-middle" style="width: 12em" scope="col">CORRECTIVE ACTION</th>
                <th class="align-middle" style="width: 12em" scope="col">PREVENTATIVE MEASURE</th>
                <th class="align-middle" style="width: 12em" scope="col" @click="changeSortingPosition('occurrences')">
                  <div class="white-space-no-wrap">
                    NUMBER OF FINDINGS
                    <span style="cursor: pointer" class="h6 ml-2">
                      <font-awesome-icon icon="arrow-up" v-if="params.direction === 'asc' && params.order_by === 'occurrences'" class="sort-arrow-up"/>
                      <font-awesome-icon icon="arrow-down" v-else-if="params.direction === 'desc' && params.order_by === 'occurrences'" class="sort-arrow-down"/>
                      <font-awesome-icon icon="sort" v-else/>
                    </span>
                  </div>
                </th>
                <th class="align-middle" style="width: 12em" scope="col">REVISION NUMBER</th>
              </tr>
              </thead>

              <tbody>

              <tr v-if="isLoading">
                <td colspan="100%" class="text-center">
                  <app-loading></app-loading>
                </td>
              </tr>

              <tr v-else-if="commonFindingsReportRs.length === 0">
                <td colspan="100%" class="text-center font-weight-bold">
                  NO FINDINGS FOUND
                </td>
              </tr>

              <template v-else>
                <template v-if="commonFindingsReportRs">
                  <template v-for="(report,index) in commonFindingsReportRs">
                    <template v-if="!!report">
                      <tr>
                        <td :rowspan="report.type_of_finding.length">
                          {{ pagination.from + index }}
                        </td>
                        <td :rowspan="report.type_of_finding.length">{{ report.finding_code }}</td>
                        <td>{{ report.type_of_finding[0] ?? '' }}</td>

                        <td style="min-width: 250px; max-width: 1250px; word-break: break-word;">
                          <template v-if="stripHtml(report.description[0]).length > 200">
                        <span v-if="!isExpanded('description-' + index + '-0')">
                          {{ stripHtml(report.description[0]).substring(0, 200) }}...
                          <a href="#" class="text-primary d-block" @click.prevent="toggleExpand('description-' + index + '-0')">
                            See More
                          </a>
                        </span>
                            <span v-else>
                          {{ stripHtml(report.description[0]) }}
                          <a href="#" class="text-primary d-block" @click.prevent="toggleExpand('description-' + index + '-0')">
                            Show Less
                          </a>
                        </span>
                          </template>
                          <template v-else>
                            {{ stripHtml(report.description[0]) }}
                          </template>
                        </td>

                        <td style="min-width: 250px; max-width: 1250px; word-break: break-word;">
                          <template v-if="stripHtml(report.root_cause_detail[0]).length > 200">
                        <span v-if="!isExpanded('root_cause-' + index + '-0')">
                          {{ stripHtml(report.root_cause_detail[0]).substring(0, 200) }}...
                          <a href="#" class="text-primary d-block" @click.prevent="toggleExpand('root_cause-' + index + '-0')">
                            See More
                          </a>
                        </span>
                            <span v-else>
                          {{ stripHtml(report.root_cause_detail[0]) }}
                          <a href="#" class="text-primary d-block" @click.prevent="toggleExpand('root_cause-' + index + '-0')">
                            Show Less
                          </a>
                        </span>
                          </template>
                          <template v-else>
                            {{ stripHtml(report.root_cause_detail[0]) }}
                          </template>
                        </td>

                        <td style="min-width: 250px; max-width: 1250px; word-break: break-word;">
                          <template v-if="stripHtml(report.correctiveAction[0].instruction).length > 200">
                        <span v-if="!isExpanded('corrective-' + index + '-0')">
                          {{ stripHtml(report.correctiveAction[0].instruction).substring(0, 200) }}...
                          <a href="#" class="text-primary d-block" @click.prevent="toggleExpand('corrective-' + index + '-0')">
                            See More
                          </a>
                        </span>
                            <span v-else>
                          {{ stripHtml(report.correctiveAction[0].instruction) }}
                          <a href="#" class="text-primary d-block" @click.prevent="toggleExpand('corrective-' + index + '-0')">
                            Show Less
                          </a>
                        </span>
                          </template>
                          <template v-else>
                            {{ stripHtml(report.correctiveAction[0].instruction) }}
                          </template>
                        </td>

                        <td style="min-width: 250px; max-width: 1250px; word-break: break-word;">
                          <template v-if="stripHtml(report.preventativeMeasure[0].description).length > 200">
                        <span v-if="!isExpanded('preventative-' + index + '-0')">
                          {{ stripHtml(report.preventativeMeasure[0].description).substring(0, 200) }}...
                          <a href="#" class="text-primary d-block" @click.prevent="toggleExpand('preventative-' + index + '-0')">
                            See More
                          </a>
                        </span>
                            <span v-else>
                          {{ stripHtml(report.preventativeMeasure[0].description) }}
                          <a href="#" class="text-primary d-block" @click.prevent="toggleExpand('preventative-' + index + '-0')">
                            Show Less
                          </a>
                        </span>
                          </template>
                          <template v-else>
                            {{ stripHtml(report.preventativeMeasure[0].description) }}
                          </template>
                        </td>

                        <td :rowspan="report.type_of_finding.length">{{ report.occurrences }}</td>
                        <td :rowspan="report.type_of_finding.length">{{ report.revisionNumber }}</td>
                      </tr>
                      <tr v-for="(type, typeIndex) in report.type_of_finding.slice(1)" :key="typeIndex">
                        <td>{{ type ?? '' }}</td>

                        <td style="min-width: 250px; max-width: 1250px; word-break: break-word;">
                          <template v-if="stripHtml(report.description[typeIndex + 1]).length > 200">
                        <span v-if="!isExpanded('description-' + index + '-' + (typeIndex + 1))">
                          {{ stripHtml(report.description[typeIndex + 1]).substring(0, 200) }}...
                          <a href="#" class="text-primary d-block" @click.prevent="toggleExpand('description-' + index + '-' + (typeIndex + 1))">
                            See More
                          </a>
                        </span>
                            <span v-else>
                          {{ stripHtml(report.description[typeIndex + 1]) }}
                          <a href="#" class="text-primary d-block" @click.prevent="toggleExpand('description-' + index + '-' + (typeIndex + 1))">
                            Show Less
                          </a>
                        </span>
                          </template>
                          <template v-else>
                            {{ stripHtml(report.description[typeIndex + 1]) }}
                          </template>
                        </td>

                        <td style="min-width: 250px; max-width: 1250px; word-break: break-word;">
                          <template v-if="stripHtml(report.root_cause_detail[typeIndex + 1]).length > 200">
                        <span v-if="!isExpanded('root_cause-' + index + '-' + (typeIndex + 1))">
                          {{ stripHtml(report.root_cause_detail[typeIndex + 1]).substring(0, 200) }}...
                          <a href="#" class="text-primary d-block" @click.prevent="toggleExpand('root_cause-' + index + '-' + (typeIndex + 1))">
                            See More
                          </a>
                        </span>
                            <span v-else>
                          {{ stripHtml(report.root_cause_detail[typeIndex + 1]) }}
                          <a href="#" class="text-primary d-block" @click.prevent="toggleExpand('root_cause-' + index + '-' + (typeIndex + 1))">
                            Show Less
                          </a>
                        </span>
                          </template>
                          <template v-else>
                            {{ stripHtml(report.root_cause_detail[typeIndex + 1]) }}
                          </template>
                        </td>

                        <td style="min-width: 250px; max-width: 1250px; word-break: break-word;">
                          <template v-if="stripHtml(report.correctiveAction[typeIndex + 1].instruction).length > 200">
                        <span v-if="!isExpanded('corrective-' + index + '-' + (typeIndex + 1))">
                          {{ stripHtml(report.correctiveAction[typeIndex + 1].instruction).substring(0, 200) }}...
                          <a href="#" class="text-primary d-block" @click.prevent="toggleExpand('corrective-' + index + '-' + (typeIndex + 1))">
                            See More
                          </a>
                        </span>
                            <span v-else>
                          {{ stripHtml(report.correctiveAction[typeIndex + 1].instruction) }}
                          <a href="#" class="text-primary d-block" @click.prevent="toggleExpand('corrective-' + index + '-' + (typeIndex + 1))">
                            Show Less
                          </a>
                        </span>
                          </template>
                          <template v-else>
                            {{ stripHtml(report.correctiveAction[typeIndex + 1].instruction) }}
                          </template>
                        </td>

                        <td style="min-width: 250px; max-width: 1250px; word-break: break-word;">
                          <template v-if="stripHtml(report.preventativeMeasure[typeIndex + 1].description).length > 200">
                        <span v-if="!isExpanded('preventative-' + index + '-' + (typeIndex + 1))">
                          {{ stripHtml(report.preventativeMeasure[typeIndex + 1].description).substring(0, 200) }}...
                          <a href="#" class="text-primary d-block" @click.prevent="toggleExpand('preventative-' + index + '-' + (typeIndex + 1))">
                            See More
                          </a>
                        </span>
                            <span v-else>
                          {{ stripHtml(report.preventativeMeasure[typeIndex + 1].description) }}
                          <a href="#" class="text-primary d-block" @click.prevent="toggleExpand('preventative-' + index + '-' + (typeIndex + 1))">
                            Show Less
                          </a>
                        </span>
                          </template>
                          <template v-else>
                            {{ stripHtml(report.preventativeMeasure[typeIndex + 1].description) }}
                          </template>
                        </td>
                      </tr>
                    </template>
                    <template v-else>
                      <tr class="border-bottom">
                        <td colspan="9">NO COMMON FINDINGS FOUND</td>
                      </tr>
                    </template>
                  </template>
                </template>
              </template>

              </tbody>
            </table>
          </div>
        </div>
      </div>
    </template>

    <div class="modal fade" data-keyboard="false" data-backdrop="static" id="risqFindingCodesModal" tabindex="-1">
      <div class="modal-dialog modal-dialog-centered modal-lg">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title font-weight-bold">SELECT RISQ FINDING</h5>
            <button type="button" class="close" @click="discardSelectedRsCodes" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true" >&times;</span>
            </button>
          </div>

          <div class="modal-body overflow-auto " style="height: 50vh">
            <template v-for="(node,index) in rsncQuestionKeys">
              <div class="row align-items-start d-flex pl-2 pt-2 pb-2">
                <h6 class="h6 text-uppercase" style="font-weight: bold">SECTION {{node.code}}: {{node.main_question}}</h6>
              </div>
              <template v-for="(child, index) in node.children">
                <div class="form-check form-check-inline align-items-start d-flex pb-2">
                  <input
                    type="checkbox"
                    class="form-check-input expand-25-percent mr-2 mt-1 cursor-pointer"
                    :id="'code-' + child.id"
                    :value="child.id"
                    v-model="modalRsCodes"
                  />
                  <label :for="'code-' +child.id" class="form-check-label d-inline-flex flex-wrap h6 text-left cursor-pointer"
                         :class="{ 'font-weight-bold': modalRsCodes.includes(child.id) }">
                    {{child.code}} {{ child.main_question }}
                  </label>
                </div>
              </template>
            </template>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-primary btn-sm" data-dismiss="modal" @click="applySelectedRsCodes">Select</button>
          </div>
        </div>
      </div>
    </div>

    <div class="modal fade" data-keyboard="false" data-backdrop="static" id="risqFindingSectionsModal" tabindex="-1">
      <div class="modal-dialog modal-dialog-centered modal-lg">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title font-weight-bold">SELECT RISQ FINDING SECTION</h5>
            <button type="button" class="close" @click="discardSelectedRsSections" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true" >&times;</span>
            </button>
          </div>

          <div class="modal-body overflow-auto" style="height: 50vh">
            <template v-for="(node,index) in rsncQuestionKeys">
              <div class="form-check form-check-inline align-items-start d-flex pb-2">
                <input
                  type="checkbox"
                  class="form-check-input expand-25-percent mr-2 mt-1 cursor-pointer"
                  :id="'section-' + node.id"
                  :value="node.id"
                  v-model="modalRsSections"
                />
                <label :for="'section-' + node.id" class="form-check-label d-inline-flex flex-wrap h6 text-left text-uppercase cursor-pointer"
                       :class="{ 'font-weight-bold': modalRsSections.includes(node.id) }">SECTION {{ node.code }}: {{ node.main_question }}</label>
              </div>
            </template>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-primary btn-sm" data-dismiss="modal" @click="applySelectedRsSections">Select</button>
          </div>
        </div>
      </div>
    </div>

    <div class="modal fade" data-keyboard="false" data-backdrop="static" id="risqTypeOfFindingsModal" tabindex="-1">
      <div class="modal-dialog modal-dialog-centered modal-md">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title font-weight-bold">SELECT TYPE OF RISQ FINDING</h5>
            <button type="button" class="close" @click="discardSelectedRsTypes" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true" >&times;</span>
            </button>
          </div>

          <div class="modal-body overflow-auto" style="height: 50vh">
            <template v-for="(node,index) in rsTypeOfFindings">
              <div class="form-check form-check-inline align-items-start d-flex pb-2">
                <input
                  type="checkbox"
                  class="form-check-input expand-25-percent mr-2 mt-1 cursor-pointer"
                  :id="'type-' + node.id"
                  :value="node.id"
                  v-model="modalRsTypes"
                />
                <label :for="'type-' + node.id" class="form-check-label d-inline-flex flex-wrap h6 text-left cursor-pointer text-uppercase"
                       :class="{ 'font-weight-bold': modalRsTypes.includes(node.id) }">{{ node.type }}</label>
              </div>
            </template>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-primary btn-sm" data-dismiss="modal" @click="applySelectedRsTypes">Select</button>
          </div>
        </div>
      </div>
    </div>

    <div class="modal fade" data-keyboard="false" data-backdrop="static" id="risqFindingRevisionsModal" tabindex="-1">
      <div class="modal-dialog modal-dialog-centered modal-md">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title font-weight-bold">SELECT REVISION NUMBER</h5>
            <button type="button" class="close" @click="discardSelectedRsRevisions" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true" >&times;</span>
            </button>
          </div>

          <div class="modal-body overflow-auto" style="height: 50vh">
            <template v-for="(node,index) in revisions">
              <div class="form-check form-check-inline align-items-start d-flex pb-2">
                <input
                  type="checkbox"
                  class="form-check-input expand-25-percent mr-2 mt-1 cursor-pointer"
                  :id="'revision-' + node.id"
                  :value="node.id"
                  v-model="modalRsRevisions"
                />
                <label :for="'revision-' + node.id" class="form-check-label d-inline-flex flex-wrap h6 text-left cursor-pointer"
                       :class="{ 'font-weight-bold': modalRsRevisions.includes(node.id) }">v{{ node.revision_number }}</label>
              </div>
            </template>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-primary btn-sm" data-dismiss="modal" @click="applySelectedRsRevisions">Select</button>
          </div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import {mapActions, mapGetters} from "vuex";
import AppLoading from "@/components/elements/AppLoading.vue";
import {PaginationMixin} from "@/mixins/PaginationMixin";
import _ from "lodash";
import AttachmentMixin from "@/mixins/attachmentMixin";
import RsncQuestionComponent from "@/components/modules/rightship/RsncQuestionComponent.vue";
import {RS_REPORT_INDEX} from "@/services/ConstantService";
import {UrlService} from "@/services/UrlService";
import axios from "axios";
import {GlobalService} from "@/services/GlobalService";
import {permissionMixin} from "@/mixins/permissionMixins";

export default {
  name: "RsCommonFindings",
  components:{RsncQuestionComponent, AppLoading},
  mixins:[PaginationMixin,AttachmentMixin, permissionMixin],
  data(){
    return {
      rsTypeOfFindings: [
        { id: 1, type: 'Deficiency' },
        { id: 2, type: 'Observation' },
        { id: 3, type: 'Recommendation' }
      ],
      modalRsRevisions: [],
      modalRsTypes: [],
      modalRsSections: [],
      modalRsCodes: [],
      expandedFindings: {},
      code:{},
      isLoading:false,
      params:{
        vessel:null,
        page:1,
        perPage:30,
        month: new Date().getMonth() + 1,
        year: new Date().getFullYear(),
        rs_section: [],
        revision_number_id: [],
        rs_code: [],
        type_of_finding: [],
        order_by:"occurrences",
        direction:"desc",
      },
      months:[
        {
          id:1,
          name:'JANUARY'
        },
        {
          id:2,
          name:'FEBRUARY'
        },
        {
          id:3,
          name:'MARCH'
        },
        {
          id:4,
          name:'APRIL'
        },
        {
          id:5,
          name:'MAY'
        },
        {
          id:6,
          name:'JUNE'
        },
        {
          id:7,
          name:'JULY'
        },
        {
          id:8,
          name:'AUGUST'
        },
        {
          id:9,
          name:'SEPTEMBER'
        },
        {
          id:10,
          name:'OCTOBER'
        },
        {
          id:11,
          name:'NOVEMBER'
        },
        {
          id:12,
          name:'DECEMBER'
        },
      ],
      years:Array.from({length:100},(_,i)=>new Date().getFullYear() - i)
    }
  },
  computed:{
    ...mapGetters(['commonFindingsReportRs','vesselKeys', 'rsncQuestionKeys']),
    ...mapGetters('revision', ['revisions']),
    showSelectedRsCodes() {
      if (!this.params.rs_code || this.params.rs_code.length === 0) {
        return '--- ALL FINDINGS ---';
      }

      const allChildren = this.rsncQuestionKeys.flatMap(node => node.children);

      const selectedCodes = this.params.rs_code
        .map(id => {
          const child = allChildren.find(c => c.id === id);
          return child ? child.code : null;
        })
        .filter(Boolean);

      return selectedCodes.join(', ');
    },
    showSelectedRsSections() {
      if (!this.params.rs_section || this.params.rs_section.length === 0) {
        return '--- ALL FINDING SECTIONS ---';
      }

      const selectedSections = this.params.rs_section
        .map(id => {
          const parent = this.rsncQuestionKeys.find(node => node.id === id);
          return parent ? `SECTION ${parent.code}` : null;
        })
        .filter(Boolean);

      return selectedSections.join(', ');
    },
    showSelectedRsTypes() {
      if (!this.params.type_of_finding || this.params.type_of_finding.length === 0) {
        return '--- ALL TYPES OF FINDING ---';
      }
      const selected = this.rsTypeOfFindings
        .filter(t => this.params.type_of_finding.includes(t.id))
        .map(t => t.type);

      return selected.join(', ');
    },

    showSelectedRsRevisions() {
      if (!this.params.revision_number_id || this.params.revision_number_id.length === 0) {
        return '--- ALL REVISION NUMBERS ---';
      }

      const selectedRevisions = this.revisions
        .filter(r => this.params.revision_number_id.includes(r.id))
        .map(r => r.revision_number);

      return selectedRevisions.join(', ');
    },
  },
  methods:{
    ...mapActions(['getCommonFindingsReportsRs','getVesselKeys', 'getRsncQuestionKeys']),
    ...mapActions('revision', ['fetchRevisions']),
    applySelectedRsRevisions() {
      this.params.revision_number_id = [...this.modalRsRevisions];
      this.params.page = 1;
    },
    discardSelectedRsRevisions() {
      this.modalRsRevisions = [...this.params.revision_number_id];
    },
    applySelectedRsTypes() {
      this.params.type_of_finding = [...this.modalRsTypes];
      this.params.page = 1;
    },
    discardSelectedRsTypes() {
      this.modalRsTypes = [...this.params.type_of_finding];
    },
    applySelectedRsSections() {
      this.params.rs_section = [...this.modalRsSections];
      this.params.page = 1;
    },
    discardSelectedRsSections() {
      this.modalRsSections = [...this.params.rs_section];
    },
    applySelectedRsCodes() {
      this.params.rs_code = [...this.modalRsCodes];
      this.params.page = 1;
    },
    discardSelectedRsCodes() {
      this.modalRsCodes = [...this.params.rs_code];
    },

    toggleExpand(id) {
      this.$set(this.expandedFindings, id, !this.isExpanded(id));
    },

    isExpanded(id) {
      return !!this.expandedFindings[id];
    },

    showRsInspection(inspectionId) {
      this.$router.push(
        {
          name: 'RsMain',
          params: {
            id: inspectionId
          }
        }
      );
    },
    showRsInspectionOnNewTab(inspectionId) {
      const route= this.$router.resolve(
        {
          name: 'RsMain',
          params: {
            id: inspectionId,
          },
        },
      )
      window.open(route.href,'_blank')
    },
    decodeHtml(html) {
      const txt = document.createElement('textarea');
      txt.innerHTML = html;
      return txt.value;
    },

    stripHtml(html) {
      if (!html) return '';
      let decoded = this.decodeHtml(html);
      return decoded.replace(/<[^>]*>?/gm, ' ').replace(/\s+/g, ' ').trim();
    },

    sortRsncKeys() {
      const collator = new Intl.Collator(undefined, {numeric: true, sensitivity: 'base'});
      this.rsncQuestionKeys.sort((a, b) => collator.compare(a.code, b.code));
    },
    async setPage(page = null){
      delete this.params.type
      this.isLoading=true;
      this.params.page = page ?? 1;
      try {
        await this.getCommonFindingsReportsRs(this.params);
      } catch (e) {
        console.error('Error fetching common finding reports:', e);
      } finally {
        this.isLoading = false;
      }
      swal.close();
      this.isLoading=false;
    },
    async resetFilter() {
      this.params=Object.assign({},{
        vessel:null,
        page:1,
        perPage:30,
        month: new Date().getMonth() + 1,
        year: new Date().getFullYear(),
        revision_number_id: [],
        rs_code: [],
        rs_section: [],
        type_of_finding: [],
        order_by:"occurrences",
        direction:"'desc",
      })
      this.modalRsCodes = [];
      this.modalRsSections = [];
      this.modalRsTypes = [];
      this.modalRsRevisions = [];
      this.code={};
      this.expandedFindings = {};
      window.location.reload();
    },
    async downloadReport(fileType){
      const params=this.params
      params[fileType]=1;
      fileType === 'excel' ? delete params.pdf : delete params.excel;

      const uri = [RS_REPORT_INDEX, 'common-findings'].join('/')
      const queryString= UrlService.setQueryString(params)
      swal.fire({
        'title': `GENERATING COMMON FINDINGS REPORT <br>Please wait.....`,
        allowOutsideClick: false,
        allowEscapeKey: false,
        allowEnterKey: false
      })
      swal.showLoading()
      await axios({
        url:uri + queryString,
        method: 'GET',
        responseType: 'blob'
      })
        .then(response => {
          swal.close()
          let mime_type = fileType==='pdf' ? 'application/pdf' : 'application/vnd.ms-excel'
          let url = window.URL.createObjectURL(new Blob([response.data],{type:mime_type}))

          fileType = (fileType !== 'pdf') ? 'xlsx' : 'pdf';

          let filename=`RS_COMMON_FINDINGS_REPORT_${Date.now()}.${fileType}`
          const link = document.createElement('a');
          link.setAttribute('href', url);
          link.setAttribute('download', filename);
          document.body.appendChild(link);
          link.click();
        }).catch(error => {
          GlobalService.handleError(error, 'DOWNLOAD RS COMMON FINDINGS SERVICE')
          return false
        }).finally(() => {
          delete this.params.pdf;
          delete this.params.excel;
        });
    },
    changeSortingPosition(column){
        swal.fire({
          'title': 'Sorting The Common Findings',
          text: 'Please wait...',
          allowOutsideClick: false,
          allowEscapeKey: false,
          allowEnterKey: false
        });
        swal.showLoading();


        this.params.direction = this.params.direction === "asc" ? "desc" : "asc";
        this.params.order_by = column


    }
  },
  created() {
    this.debouncedSetPage=_.debounce(this.setPage,750);
    this.getVesselKeys();
    this.getRsncQuestionKeys().then(() => {
      this.sortRsncKeys();
    });
    this.fetchRevisions();
    this.setPage();
  },

  watch:{
    "params.year"(){
      this.debouncedSetPage();
    },
    "params.month"(){
      this.debouncedSetPage();
    },
    "params.vessel"(){
      this.debouncedSetPage();
    },
    "params.rs_section"(){
      this.debouncedSetPage();
    },
    "params.revision_number_id"(){
      this.debouncedSetPage();
    },
    "params.rs_code"(){
      this.debouncedSetPage();
    },
    "params.order_by"(){
      this.debouncedSetPage();
    },
    "params.direction"(){
      this.debouncedSetPage();
    },
  }
}
</script>
<style scoped>
.custom-button:disabled {
  background-color: #e9ecef;
  opacity: 1;
}
.border-bottom {
  border-bottom: 2px solid black !important;
}
</style>
